//Helpers

import { toast } from '@Shelly/shelly-design-system';
import { postReq } from 'src/services/http';
import { devices } from 'src/stores/lists/devices';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

let $format = get(format);

export const eraseOrCancelAIModel = async (device) => {
	let { id } = device;
	//1. reset the AI model
	//2. toggle off the AI model. This will stop the learning process and the AI model will be paused or stopped
	//3. delete the ai_device_failure key from the cloud_options object. This will show the introduction screen and restore the default state of the AI model
	let resReset = await postReq(`device/reset_ai`, {
		id: id,
	});

	if (resReset?.isok) {
		const resSetCloudOpts = await postReq('interface/device/set_cloud_options', {
			id: device.id,
			set: 'ai_device_failure',
			val: false,
		});

		if (resSetCloudOpts?.isok) {
			toast.open({
				type: 'success',
				title: $format('toast_title_erase_ai_model', {
					default: 'Sending a request to reset the AI model',
				}),
			});

			const delSetCloudOpts = await postReq('interface/device/set_cloud_options', {
				id: device.id,
				set: 'ai_device_failure',
				del: 1,
			});

			if (delSetCloudOpts?.isok) {
				toast.open({
					type: 'success',
					title: $format('toast_title_success_resetting_ai_model', {
						default: 'Success resetting AI Model.',
					}),
				});
			}

			return delSetCloudOpts;
		} else {
			console.error('Failed in second step - toggle off AI model. Error: ', resSetCloudOpts);
			toast.open({
				type: 'danger',
				title: $format('toast_title_erase_ai_model_failed', {
					default: 'Failed to send AI model reset request',
				}),
			});
		}
	} else {
		console.error('Failed in first step - reset AI model. Error: ', resReset);
		toast.open({
			type: 'danger',
			title: $format('toast_title_erase_ai_model_failed', {
				default: 'Failed to send AI model reset request',
			}),
		});
	}
};

export const eraseOrCancelAIModelBulk = async (selectedDevices, type) => {
	//1. reset the AI model
	//2. toggle off the AI model. This will stop the learning process and the AI model will be paused or stopped
	//3. delete the ai_device_failure key from the cloud_options object. This will show the introduction screen and restore the default state of the AI model
	let resReset = await postReq(`device/reset_ai`, {
		devices: JSON.stringify(selectedDevices.map((device) => device.id)),
		bulk: 1,
	});

	if (resReset?.isok) {
		const resSetCloudOpts = await postReq('interface/device/bulk_cloud_options', {
			set: type,
			val: false,
			devices: JSON.stringify(selectedDevices.map((device) => device.id)),
		});

		if (resSetCloudOpts?.isok) {
			toast.open({
				type: 'success',
				title: $format('toast_title_erase_ai_model', {
					default: 'Sending a request to reset the AI model',
				}),
			});

			const delSetCloudOpts = await postReq('interface/device/bulk_cloud_options', {
				devices: JSON.stringify(selectedDevices.map((device) => device.id)),
				set: 'ai_device_failure',
				del: 1,
			});

			if (delSetCloudOpts?.isok) {
				toast.open({
					type: 'success',
					title: $format('toast_title_success_resetting_ai_model', {
						default: 'Success resetting AI Model.',
					}),
				});
			}

			return delSetCloudOpts;
		} else {
			console.error('Failed in second step - toggle off AI model. Error: ', resSetCloudOpts);
			toast.open({
				type: 'danger',
				title: $format('toast_title_erase_ai_model_failed', {
					default: 'Failed to send AI model reset request',
				}),
			});
		}
	} else {
		console.error('Failed in first step - reset AI model. Error: ', resReset);
		toast.open({
			type: 'danger',
			title: $format('toast_title_erase_ai_model_failed', {
				default: 'Failed to send AI model reset request',
			}),
		});
	}
};
